<template>
	<div>
		<div class="col-md-4 pt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail&&(viewToggle||!clickToggle)}">
			<div class="right_list_content" >
				<p id="right_content_title_information" class="pl-3 mb-0">
					<i class="fa fa-play-circle-o fa-lg mr-2"></i>Videos
                    <!--<button class="btn genceback float-right mt-3" @click="videoclassify('一带一路视频')">全部</button>-->
				</p>
				<!--<div class="d-flex right_information_dropdown">
					<div class=" p-2 flex-fill align-middle videotab videotabbor" @click="videoclassify('丝路趣闻')">
						<a href="javascript:" class="text-darks" :class="selectedColumn =='丝路趣闻'?'videotabbors':''">丝路趣闻</a>
					</div>
					<div class=" p-2 flex-fill align-middle videotab" @click="videoclassify('丝路之声')">
						<a href="javascript:" class="text-darks" :class="selectedColumn =='丝路之声'?'videotabbors':''">丝路之声</a>
					</div>
					<div class=" p-2 flex-fill align-middle videotab" @click="videoclassify('一带一路纪录片')">
						<a href="javascript:" class="text-darks" :class="selectedColumn =='一带一路纪录片'?'videotabbors':''">一带一路纪录片</a>
					</div>
				</div>-->
				<div class="row nano video_breviary m-0 videosig_list" id="video_breviary">
					<div class="nano-content" id="home_right_list" :class="{'cur':!viewToggle}">
                        <ul class="list-unstyled">
						<li v-for="(value,key) in videoLists" class="media pb-4 pt-4 pl-4 pr-3 border-bottom">

							<img class="mr-3 img-thumbnail probations_img" :src="value.thumb" />
							<div class="media-body">
								<h5>
									<i class="fa fa-film mr-2"></i>
                                    <router-link class="f15 text-dark font-weight-bold" :value="value.resourceId" :to ="{name:'videoId',params :{contentid:subContentId(value.resourceId)}}">{{ value.title }}</router-link>
								</h5>
								<p class="f13">Duration:　{{formatSeconds(duration(value.description))}}</p>
								<div class="clearfix" style="line-height: 22px;">
									<div class="float-left">
										<span class="border border-primary text-primary f12 p-11"><a href="javascript:" @click="videoclassify(value.catName)">{{ value.catName }}</a></span>

									</div>
									<div class="float-left pr-3 pl-3" v-if="value.published">
										<img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
									</div>
									<div class="float-left" v-if="value.published">
										<span class="f12 text-muted">{{timeDiff(value.published)}}</span>
									</div>
								</div>
							</div>
						</li>
						<!--<div class="col-md-6 col-6 p-0" v-for="(value,key) in videoType" v-if="value.modelType == 'video'" @click="getVideo(value.resourceId)">
							<div class="card">
								<div class="card-body">
									<div style="position: relative;">
										<img class="card-img-top" :src="value.thumb" alt="Card image cap">
											<span class="video_time">
												{{value.description}}
											</span>
											<div class="card-img-hover">
												<i class="fa fa-play-circle-o"></i>
											</div>
									</div>
									<p class="card-text">{{value.title}}</p>
								</div>
							</div>

						</div>-->
						<!--<p class="w-100 text-center" style="height: 50px;">没有更多了...</p>-->
                        <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
                        </ul>
						<div v-if="endShow" class="w-100">
							<p class="text-center p-2">loading....</p>
						</div>
                        <div v-if="!loadShow&&videoLists.length ==0" class="nodata text-center w-100">
                        <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100"  alt="">
                        <p class="text-center p-2">loading</p>
                        </div>
					</div>
				</div>

			</div>
		</div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}">
            <videoArticle></videoArticle>
		</div>
	</div>
</template>
<script>
    import videoArticle from './ArticleDetails/videoArticle.vue'
	export default({
		name: 'video_signal',
		data: function() {
			return {
				checkpay:1,
				videoLists: [],
				page: 0,
				total_page: 1,
				reveal: false,
				detailes: [],
				token: '',
                selectedColumn:'Video',
//                tabType:"a"
                viewToggle:true,
                specail:false, //特殊处理 小于544px
                clickToggle:true,
                loadShow:true,
                endShow:false
			}
		},
        computed: {
            isFollow () {
                return this.$store.state.screenWidth;
            }
        },
        watch: {
            isFollow (val) {
                if (!this.timer) {
                    //this.screenWidths = val;
                    this.timer = true;
                    let that = this;
                    setTimeout(function () {
                        if(that.IsPC()&&(val<=700)){
                            that.specail=true
                        }else{
                            that.specail=false
                        }
                        that.timer = false
                    }, 300)
                }

            }
        },
		created: function() {
            var that = this;
            this.viewToggle=this.IsPC();
            if(this.IsPC()&&(document.body.clientWidth<=700)){
                this.specail=true
            }else{
                this.specail=false
            }
            this.$axios({
                url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/0/' + encodeURI(this.selectedColumn) + '/0',
                method: 'get'
            }).then(data => {
                that.videoLists = data.data.results
                that.videoLists = that.videoLists.filter(item => item.modelType == 'video');
                that.token = data.data.token;
                that.total_page = data.data.totalPage;
                that.loadShow = false;
                    // 过滤视频
                    /*that.videoLists.forEach(item => {
                        if (item.modelType = 'video') {
                            that.videoLists[that.videoLists.length] = item;
                        }
                    })*/

                    that.$router.push({
                        name: 'videoId',
                        params: {
                            contentid: that.$route.params.contentid ? that.$route.params.contentid : that.subContentId(that.videoLists[0].resourceId)
                        }
                    });
            }, function(response) {
                console.info(response);
                if(response) {
                    console.log("失败");
                }
            })
		},
		mounted() {
			document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
			this.load();
		},
		methods: {
		    clickToggles(){
                this.clickToggle=false;
            },
            goback(){
                if(this.viewToggle){
                    // this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:1}})
                }else{
                    this.clickToggle=true;
                }

            },
			checkpays:function(index){
	            this.checkpay=index;
	        },
			videoclassify: function(column) {
                this.selectedColumn = column;
                this.getVideoList();
			},
			handleScroll() {
				var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_right_list').scrollHeight; // 总高度

				if(((all - 20) < (top + client)) && !this.loadShow) {
					this.page++;
					if(this.page > this.total_page) {
					    this.endShow = true;
						return;
					}
					this.loadShow = true;
                    let that = this;
					this.$axios({
						url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/'+this.page+'/0/' + encodeURI(this.selectedColumn)+ '/0',
						method: 'get',
						headers: {
							token: that.token
						}

					}).then(data => {
                        var videoList = data.data.results;
                        videoList = videoList.filter(item => item.modelType == 'video');
                        that.token = data.data.token;
                        that.total_page = data.data.totalPage;
                        that.videoLists = that.videoLists.concat(videoList);
                        that.loadShow = false;

					}, function(response) {
						console.info(response);
						if(response) {
							console.log("失败");
						}
					})
				}

			},
			timeDiff(published) {
                var now = new Date();
                var date3 = now.getTime() - published;

                // 计算相差年数
                var years =  Math.floor(date3 / (356 * 24 * 3600 * 1000))
                //计算出相差天数
                var days = Math.floor(date3 / (24 * 3600 * 1000))
                //计算出小时数
                var hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                var minutes = Math.floor(date3 / (60 * 1000))
                // 计算相差秒数
                var seconds = Math.floor(date3 / 1000)

                if (years > 0) {
                    var time = new Date(published);
                    var y = time.getFullYear();
                    var m = time.getMonth()+1;
                    var d = time.getDate();
                    return y + '-' + m + '-' + d;
                }

                if(days > 0) {
                    if (days > 7) {
                        var time = new Date(published);
                        var m = time.getMonth()+1;
                        var d = time.getDate();
                        return m + '-' + d;
                    } else {
						if(days==1){
							return days + 'day ago';
						}
						return days + 'days ago';
                    }
                }

                if(hours > 0) {
					if(hours==1){
						return hours + 'hour ago';
					}
					return hours + 'hours ago';
                }

                if(minutes > 0) {
					if(minutes==1){
						return minutes + 'minute ago';
					}
					return minutes + 'minutes ago';
                }
                if (seconds > 0) {
					if(seconds==1){
						return  seconds + 'second ago';
					}
					return  seconds + 'seconds ago';
                }
			},
			subContentId(contentid) {
                // 查找 站点是否存在
                var start = contentid.indexOf('_');

                if (start > 0) {
                    var arr = contentid.split('_');
                    return arr[1];
                } else {
                    return contentid;
                }

            },
            duration(duration) {
                // 查找 站点是否存在
                var start = duration.indexOf('|');

                if (start >= 0) {
                    var arr = duration.split('|');
                    return arr[1];
                } else {
                    return duration;
                }

            },
            getVideoList() {
			    var that = this;
                this.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/0/' + encodeURI(this.selectedColumn) + '/0',
                    method: 'get'
                }).then(data => {
                    that.videoLists = data.data.results;
                    that.token = data.data.token;
                    that.total_page = data.data.totalPage;

                }, function(response) {
                    console.info(response);
                    if(response) {
                        console.log("失败");
                    }
                })
            },
            formatSeconds(value) {
                var secondTime = parseInt(value); // 秒
                var minuteTime = 0; // 分
                if(secondTime > 60) {
                    minuteTime = parseInt(secondTime / 60);
                    secondTime = parseInt(secondTime % 60);
                    return this.PrefixInteger(parseInt(minuteTime), 2) + ':' + this.PrefixInteger(secondTime, 2);
                } else {
                    return "00:" + this.PrefixInteger(parseInt(secondTime), 2);
                }

            },
            PrefixInteger(num, n) {
                return(Array(n).join(0) + num).slice(-n);
            }
		},
        components: {
            videoArticle
        }
	})
</script>
<style type="text/css" scoped>
    .mp-2{
        margin-bottom: 0!important;
        padding-bottom: .2rem!important;
    }
    .videotabbors{
        border-bottom: 2px solid rgba(32,142,255,1);
        padding-bottom:1.2rem;
        color: #333!important;
    }
    .text-darks{
        color:#9092A6
    }
    .p11{
        padding: .125rem .375rem!important;
    }
    .right_content_dropdown,.right_information_dropdown{
        line-height: 40px;
    }
</style>
<style type="text/css">
    .p11{
        padding: .125rem .375rem!important;
    }
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
</style>
